import { Component, inject, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { LookupList } from '../../../../../core/models/lookup-list.model';
import { LookupListService } from '../../../../../core/services/lookup-list.service';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-select-field',
  imports: [ReactiveFormsModule, FormlyModule, IconComponent, TranslatePipe],
  templateUrl: './select-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './select-field.component.css',
})
export class SelectFieldComponent extends FieldType<FieldTypeConfig> implements OnInit {
  private lookupListService = inject(LookupListService);
  private _lookupListSignal: Signal<LookupList | null> | null = null;

  ngOnInit(): void {
    const optionsSource = this.props['optionsSource'] as string | undefined;
    const lookupListId = this.props['lookupListId'] as string | undefined;
    if (optionsSource === 'lookup-list' && lookupListId) {
      const query = this.lookupListService.createQueryById(lookupListId);
      this._lookupListSignal = query.data;
    }
    // Apply default when the control has no value yet (new form interaction)
    if (this.formControl.value === null || this.formControl.value === undefined) {
      const defaultOpt = this.selectOptions.find((o) => o.isDefault);
      if (defaultOpt) {
        this.formControl.setValue(this.isMultiple ? [defaultOpt.value] : defaultOpt.value);
      }
    }
  }
  get selectOptions(): { value: any; label: string; description?: string; isDefault?: boolean }[] {
    if (this._lookupListSignal) {
      return this._lookupListSignal()?.options ?? [];
    }
    const opts = this.props['options'] as any;
    return Array.isArray(opts) ? opts : [];
  }

  get isMultiple(): boolean {
    return this.props['multiple'] === true;
  }

  isSelected(value: any): boolean {
    const current = this.formControl.value;
    if (Array.isArray(current)) return current.includes(value);
    return current === value;
  }

  selectOption(value: any): void {
    if (this.isMultiple) {
      const current: any[] = Array.isArray(this.formControl.value)
        ? [...this.formControl.value]
        : [];
      const idx = current.indexOf(value);
      if (idx > -1) {
        current.splice(idx, 1);
      } else {
        current.push(value);
      }
      this.formControl.setValue(current);
    } else {
      const already = this.formControl.value === value;
      this.formControl.setValue(already ? null : value);
    }
    this.formControl.markAsTouched();
  }
}
